module.exports = __webpack_public_path__ + "static/media/canLinkMe.c97b160d.png";